import { render } from "./Button.vue?vue&type=template&id=6dc50a80&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"

import "./Button.vue?vue&type=style&index=0&id=6dc50a80&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6dc50a80"

export default script